/* eslint-disable */
import * as types from '../constants/actionTypes'
import {emitAction} from '../websocket/client'
import { messageTypes } from '../websocket/messageTypes'
import * as axios from 'axios';
import config from '../config';
import { addNotification } from './notificationActions';
// const websocketUrl = config.socketserver.url + ':' + config.server.port;

// example of a thunk using the redux-thunk middleware
export function getStreamsSuccess(streams) {
  return {
    type: types.GET_STREAMS,
    streams: streams
  };
}

export function getPreviewSuccess(data) {
  return {
    type: types.PREVIEW_STREAM,
    programids: data.programids,
    filename: data.filename
  };
}
export function startStreamSuccess(containerId) {
    return {
      type: types.START_STREAM,
      containerId: containerId
  };
}
export function stopStreamSuccess(containerId) {
    return {
      type: types.STOP_STREAM,
      containerId: containerId
    };
}

export function deleteStreamSuccess(containers) {
    return {
      type: types.DELETE_STREAM,
      containers: containers
    };
}

export function importStreamsSuccess() {
  return {
    type: types.IMPORT_STREAMS
  };
}

export function getBackupsSuccess(backupFiles) {
  return {
    type: types.BACKUP_FILES,
    backupFiles: backupFiles
  };
}

export function exportStreamsSuccess() {
  return {
    type: types.EXPORT_STREAMS
  };
}

export function getLocalConfigSuccess(data) {
  return {
    type: types.GET_LOCALCONFIG,
    localConfig: data
  };
}

export const startSrtStatStream = emitAction((data) => {
  return {
    type: types.GET_SRT_STATS,
    key: messageTypes.subscribeToStats,
    payload: {
      ...data
    }
  }
})

export const requestConnectionStatus = emitAction((data) => {
  return {
    type: '',
    key: messageTypes.containerStatus,
    payload: {
      ...data
    }
  }
})

export function getPeerIPSuccess(peerIP) {
  return {
    type: types.GET_PEER_IP,
    peerIP: peerIP
  };
}

export function getStreamStatsSuccess(mode, data) {
  return {
    type: types.GET_STREAM_STATS,
    mode: mode,
    stats: data
  };
}

export function setSelectedContainer(containerId) {
  return {
    type: types.SET_SELECTED_CONTAINER,
    containerId: containerId
  };
}

export function clearTSTableReportSuccess() {
  return {
    type: types.CLEAR_TSTABLE_REPORT
  };
}

export function getTSReportInputSuccess(reportData) {
  return {
    type: types.GET_TSTABLE_REPORT_INPUT,
    reportData: reportData
  };
}

export function getTSReportOutputSuccess(reportData) {
  return {
    type: types.GET_TSTABLE_REPORT_OUTPUT,
    reportData: reportData || {
      tsID: "",
      network_name: "",
      programs: [],
      tables: []
    }
  };
}

export function getStreams(serviceUrl){
  const url = serviceUrl + '/stream';
  return function(dispatch){
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        dispatch(getStreamsSuccess(res.data));
      })
      .catch(
        (error) => {
          // Error
          console.log('Full Error', error);
          let errMsg = error.message;
          if (error.response) {
          } else if (error.request) {
              console.log(error.request);
          } else {
              console.log('Error', error.message);
          }
        
          if(errMsg.startsWith("Network Error"))
            errMsg = `Unable to connect to the engine service!`;

          dispatch(addNotification(errMsg, 'error'));
      }
      );
  }
}

export function subscribeToStats(containerId, serviceUrl){
  return function(dispatch,getState){//TODO: check how to get ContainerConfig state, need: timeout, decryption and latency
    const url = `${serviceUrl}/stream`;
    let test = getState();
    if(containerId){
      dispatch(startSrtStatStream({containerId: containerId}));
      dispatch(setSelectedContainer(containerId));
    }
    else{
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        let containerIds = res.data.map(container => container.Id);
        let containerId;
        if(containerIds)
          containerId = containerIds[0];

          if(containerId){
            dispatch(startSrtStatStream({containerId: containerId}));
            dispatch(setSelectedContainer(containerId));
            /*if(res.data.length > 0 && res.data[0].sourcePort) {
              dispatch(getPeerIP(res.data[0].sourcePort, serviceUrl));
            }*/
          }
      })
      .catch(
        (error) => {
          let errMsg = error.message;
          if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              // console.log(error.response.data);
              // console.log(error.response.status);
              // console.log(error.response.headers);
          } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
          } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
          }
          console.log(error.config);
          if(errMsg.startsWith("Network Error"))
            errMsg = `SubscribeToStats: Unable to connect to the engine service!`;

          dispatch(addNotification(errMsg, 'error'));
      }
      );
    }
  }
}

export function getPeerIP(sourcePort, serviceUrl){
  return function(dispatch){
    var url = `${serviceUrl}/stream/peerip`;
    if(sourcePort) {
      url = `${url}/${sourcePort}`;
      dispatch(getPeerIPSuccess(""));
    } else {
      console.log('port not specified');
      return;
    }
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        if(res.data.status=="success") {
          dispatch(getPeerIPSuccess(res.data.data));
        }
      })
      .catch(err => {
        console.log('error:', err.response.data);
      });
  }
}

export function getStreamStats(containerId, mode, inputFormat, outputFormat, serviceUrl){
  return function(dispatch){
    var url = `${serviceUrl}/stream/graph/${containerId}/${mode}`;
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        if(res.data.status=="success") {
          let jsonData = mode == "input" ? inputFormat(res.data.data) : outputFormat(res.data.data);
          dispatch(getStreamStatsSuccess(mode, jsonData));
        }
      })
      .catch(err => {
        console.log('error:', err);
        //console.log('error:', err.response.data);
      });
  }
}

export function startStream(containerId, serviceUrl){
  return function(dispatch){
    const url = `${serviceUrl}/stream/start/${containerId}`;
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        // dispatch(startStreamSuccess(res.data));
        dispatch(getStreams(serviceUrl));
      })
      .catch(err => {
        dispatch(addNotification(err.response.data, 'error'));
      });
  }
}

export function stopStream(containerId, serviceUrl){
  return function(dispatch){
    const url = `${serviceUrl}/stream/stop/${containerId}`;
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        // dispatch(stopStreamSuccess(res.data));
        dispatch(getStreams(serviceUrl));

      })
      .catch(err => {
        dispatch(addNotification(err.message, 'error'));
      });
  }
}

export function deleteStream(containerId, serviceUrl){
  return function(dispatch){
    const url = `${serviceUrl}/stream/${containerId}`;
    return axios.delete(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        //dispatch(deleteStreamSuccess(res.data));
        dispatch(getStreams(serviceUrl));
      })
      .catch(err => {
        dispatch(addNotification(err.message, 'error'));
      });
  }
}

export function importStreams(file, serviceUrl){
  return function(dispatch){
    var url = `${serviceUrl}/stream/import`;
    if(file) {
      url = `${url}/${file}`;
    } else {
      dispatch(addNotification("Please select file to import.", 'error'));
      return;
    }
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        dispatch(addNotification(res.data.message, res.data.status));
        if(res.data.status=="success") {
          dispatch(importStreamsSuccess());
        }
      })
      .catch(err => {
        dispatch(addNotification(err.response.data, 'error'));
      });
  }
}

export function getBackups(serviceUrl){
  const url = serviceUrl + '/stream/backups';
  return function(dispatch){
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        if(res.data.status =="success") {
          dispatch(getBackupsSuccess(res.data.data));
        } else {
          dispatch(addNotification(res.data.message, 'error'));
        }
      })
      .catch(
        (error) => {
          // Error
          let errMsg = error.message;
          if (error.response) {
          } else if (error.request) {
              console.log(error.request);
          } else {
              console.log('Error', error.message);
          }
          console.log(error.config);
          if(errMsg.startsWith("Network Error"))
            errMsg = `Unable to connect to the engine service!`;

          dispatch(addNotification(errMsg, 'error'));
      }
      );
  }
}

export function exportStreams(serviceUrl){
  return function(dispatch){
    const url = `${serviceUrl}/stream/export`;
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        dispatch(addNotification(res.data.message, res.data.status));
        if(res.data.status=="success") {
          dispatch(exportStreamsSuccess());
        }
      })
      .catch(err => {
        dispatch(addNotification(err.response.data, 'error'));
      });
  }
}

export function getLocalConfig(){
  return function(dispatch){
    var localConfig = localStorage.getItem('localConfig');
    if(localConfig) {
      dispatch(getLocalConfigSuccess(JSON.parse(localConfig)));
    }
  }
}

export function setLocalConfig(key, value){
  return function(dispatch){
    var data = {};
    var localConfig = localStorage.getItem('localConfig');
    if(localConfig) {
      data = JSON.parse(localConfig);
    }
    data[key] = value;
    localStorage.setItem('localConfig', JSON.stringify(data));
    dispatch(getLocalConfigSuccess(data));
  }
}

export function clearTSTableReport(){
  return function(dispatch){
    dispatch(clearTSTableReportSuccess());
  }
}

export function getTSTableReport(mode, containerId, reportType, destIP, destPort, ssmIP, serviceUrl){
  destIP = destIP.replace("@", "");
  return function(dispatch){
    var url = `${serviceUrl}/stream/report/${containerId}/${reportType}/${destIP}/${destPort}`;
    if(ssmIP) {
      url = `${url}/?ssm=${ssmIP}`;
    }
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        if(res.data.status=="success") {
          if(mode == "input") {
            dispatch(getTSReportInputSuccess(res.data.data));
          } else {
            dispatch(getTSReportOutputSuccess(res.data.data));
          }
        } else {
          dispatch(getTSReportOutputSuccess(null));
        }
      })
      .catch(err => {
        console.log('error:', err.response.data);
        dispatch(getTSReportOutputSuccess(null));
      });
  }
}

export function downloadReport(containerId, reportType, destIP, destPort, serviceUrl){
  destIP = destIP.replace("@", "");
  const url = `${serviceUrl}/stream/download/report/${containerId}/${reportType}/${destIP}/${destPort}`;
  var link=document.createElement('a');
  link.href = url;
  link.download = url.substr(url.lastIndexOf('/') + 1);
  //link.target="_blank"
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
  }, 100);
  return function(dispatch){
  }
}

export function previewStream(containerId, sourceProtocol, sourceIP, sourcePort, serviceUrl){
  
  sourceIP = sourceIP.replace("@", "");
  const url = `${serviceUrl}/stream/preview/${containerId}/${sourceProtocol}/${sourceIP}/${sourcePort}`;
  return function(dispatch){
       return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
       .then(res => {
         console.log("in action previewStream...",res.data);
         return dispatch(getPreviewSuccess(res.data));
       })
       .catch(
         (error) => {
           // Error
           console.log('Error', error);
           let errMsg = error.message;
           if(errMsg.startsWith("Network Error"))
             errMsg = `Unable to connect to the engine service!`;
           dispatch(addNotification(errMsg, 'error'));
         }
       );
  }
}

export function selectedProgramId(programId, containerId, sourceProtocol, sourceIP, sourcePort, serviceUrl){
  sourceIP = sourceIP.replace("@", "");
  containerId = containerId.substring(0, 12);
  const url = `${serviceUrl}/stream/convert-stream/${containerId}/${sourceProtocol}/${sourceIP}/${sourcePort}/${programId}`;
  return function(dispatch){
      return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        console.log("in action selectedProgramId...",res.data);
        return dispatch(getPreviewSuccess(res.data));
      })
      .catch(
        (error) => {
          // Error
          console.log('selectedProgramId..Error', error);
          let errMsg = error.message;
          if(errMsg.startsWith("Network Error"))
            errMsg = `Unable to connect to the engine service!`;
          dispatch(addNotification(errMsg, 'error'));
        }
      );
    }  
}
